




import Vue from 'vue'
import ShowBankName from '@/components/molecules/ShowBankName.vue'

export default Vue.extend({
  name: 'BankNameTaiko',
  components: {
    ShowBankName
  },
  props: {
    bankName: String
  }
})
